import { FormProvider } from "react-hook-form";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/view/components/ui/dialog";
import { BasicInput } from "@/view/components/BasicInput";
import { Button } from "@/view/components/ui/button";
import { cpfMask } from "@/app/utils/cpfFormater";
import useGenerateProposalModal from "./useGenerateProposalModal";
import { phoneMask } from "@/app/utils/phoneFormater";

interface GenerateProposalModalProps {
  onContinue: () => void;
  onContinuePreApproved: () => void;
  onBack: () => void;
}

export default function GenerateProposalModal({
  onContinue,
  onContinuePreApproved,
  onBack,
}: GenerateProposalModalProps) {
  const { form, submitModal, loading } = useGenerateProposalModal({
    onContinue,
    onContinuePreApproved,
  });

  const {
    formState: { errors },
  } = form;

  return (
    <DialogContent className="max-h-[90vh] max-w-[90%] overflow-y-auto md:max-w-[400px]">
      <DialogHeader className="border-b pb-4">
        <DialogTitle className="text-xl font-semibold text-black01">
          Vamos simular seu crédito
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Preencha o cpf abaixo para gerar os convênios disponíveis para
          simulação
        </DialogDescription>
      </DialogHeader>

      <form onSubmit={submitModal}>
        <FormProvider {...form}>
          <div>
            <div className="mb-4">
              <BasicInput
                name="cpf"
                maxLength={14}
                label="CPF"
                error={errors.cpf?.message}
                onInput={cpfMask}
              />
            </div>

            <div className="mb-4">
              <BasicInput
                name="phone"
                label="Telefone"
                error={errors.phone?.message}
                onInput={phoneMask}
              />
            </div>
          </div>
          <div className="mt-8 flex items-center justify-center gap-2">
            <Button
              variant="outline"
              onClick={onBack}
              className="w-[160px] rounded-full text-primary"
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="w-[160px] rounded-full font-semibold text-white "
              isLoading={loading}
              disabled={loading}
            >
              Prosseguir
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  );
}
